module.exports = __webpack_public_path__ + "img/share-2.0fb07fe6.svg";